module.exports = __webpack_public_path__ + "static/for_whom_meeting-8b095a79c35c139389a368b0385906ad.jpg";